"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _timing = require("../../timing");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cycle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Cycle, _React$Component);

  function Cycle() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, Cycle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = Cycle.__proto__ || Object.getPrototypeOf(Cycle)).call.apply(_ref, [this].concat(args))), _this.state = {
      index: 0,
      incrementCount: 0
    }, _this.render = function () {
      return React.createElement(React.Fragment, null, _this.props.active && React.createElement(_timing.Interval, {
        interval: _this.props.interval,
        key: _this.state.incrementCount
      }, _this._next(false)), _this.props.children({
        item: _this.props.items[_this.state.index],
        index: _this.state.index,
        next: _this._next(true),
        previous: _this._prev,
        goTo: _this._goTo
      }));
    }, _this.componentWillReceiveProps = function (_ref2) {
      var items1 = _ref2.items;
      // grab the current list of items
      var items2 = _this.props.items; // check if the items are the same

      if (JSON.stringify(items1) !== JSON.stringify(items2)) {
        // reset the cycle to the first element
        _this._goTo(0); // bump the increment count to reset the interval


        _this.setState(function (_ref3) {
          var incrementCount = _ref3.incrementCount;
          return {
            incrementCount: incrementCount + 1
          };
        });
      }
    }, _this._next = function (increment) {
      return function () {
        return _this.setState(function (_ref4) {
          var index = _ref4.index,
              incrementCount = _ref4.incrementCount;
          return {
            index: index === _this.props.items.length - 1 ? 0 : index + 1,
            incrementCount: incrementCount + 1
          };
        });
      };
    }, _this._prev = function () {
      return _this.setState(function (_ref5) {
        var index = _ref5.index,
            incrementCount = _ref5.incrementCount;
        return {
          index: index === 0 ? _this.props.items.length - 1 : index - 1,
          incrementCount: incrementCount + 1
        };
      });
    }, _this._goTo = function (index) {
      return _this.setState(function (_ref6) {
        var incrementCount = _ref6.incrementCount;
        return {
          index: index,
          incrementCount: incrementCount + 1
        };
      });
    }, _temp));
  }

  return Cycle;
}(React.Component);

Cycle.defaultProps = {
  active: true
};
var _default = Cycle;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/state/Cycle/index.js
// module id = ./node_modules/quark-core/components/state/Cycle/index.js
// module chunks = 0